<template>
    <el-select
      :value="innerAppid"
      size="small"
      @change="selectAccount"
      filterable
      clearable
    >
        <el-option
          v-for="item in wxAccountList"
          :key="item.appid"
          :label="`${item.name}（${$config.account_types[item.type]}）`"
          :value="item.appid"
        ></el-option>
    </el-select>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
          dataListLoading: false,
          innerAppid: '',
        }
    },
    watch:{
      selectedAppid(newVal,oldVal){
        if(newVal){
          this.innerAppid = newVal;
        }
      }
    },
    computed: {
        ...mapGetters(['wxAccountList','selectedAppid']),
    },
    created(){
      this.innerAppid = this.selectedAppid;
    },
    methods:{
        selectAccount(appid){
          this.$store.commit('updateSelectedAppid',appid);
        }
    }
}
</script>
